import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EMPTY_QUOTE = {
  name: "",
  phone: "",
  email: "",
  service: "",
  category: "Residential",
  suburb: "",
  details: "",
  contact_method: "Phone Call",
};

export const photoKey = (p) => `${p.name}-${p.size}-${p.lastModified}`;

export const useQuoteForm = () => {
  const [form, setForm] = useState(EMPTY_QUOTE);
  const [photos, setPhotos] = useState([]);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    const handler = (e) => setForm((f) => ({ ...f, service: e.detail }));
    window.addEventListener("vic:preselect-service", handler);
    return () => window.removeEventListener("vic:preselect-service", handler);
  }, []);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const choose = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const addPhotos = (files) =>
    setPhotos((p) => {
      const seen = new Set(p.map(photoKey));
      const fresh = files.filter((f) => !seen.has(photoKey(f)));
      return [...p, ...fresh.slice(0, 6 - p.length)];
    });
  const removePhoto = (idx) => setPhotos((p) => p.filter((_, j) => j !== idx));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => fd.append(k, v));
      photos.forEach((p) => fd.append("photos", p));
      await axios.post(`${API}/quote`, fd);
      toast.success("Quote request sent — we'll be in touch within 24 hours.");
      setForm(EMPTY_QUOTE);
      setPhotos([]);
    } catch (err) {
      toast.error("Something went wrong sending your request. Please call us directly.");
    } finally {
      setSending(false);
    }
  };

  return { form, photos, sending, set, choose, addPhotos, removePhoto, submit };
};
